import { Box, Stack } from "@mui/material";
import { onboardingTokens } from "../../theme";
import { t } from "../../../../locales/t";

/**
 * One segment per selected goal, filled to the current position.
 *
 * Distinct from the global progress bar above it, which reads "6 of 8" for the
 * whole of `person_flow` and does not change while the member is inside it.
 * The two answer different questions: how far through the whole flow, and how
 * far through the goals just chosen.
 *
 * Rendered by each sub-flow screen rather than by a host wrapping them. The
 * sub-flows are ordinary screens under the layout's outlet, exactly like
 * `GoalsStep`, and this is the one piece of chrome they have in common — a
 * wrapper existing only to draw it would own their sequencing too, and then
 * every screen would have to hand its state up through it.
 *
 * @param {object} props
 * @param {number} props.total    selected goals
 * @param {number} props.current  zero-based position among them
 */
const SubFlowDots = ({ total, current }) => (
  <Stack
    direction="row"
    gap={0.75}
    sx={{ mb: 3.5 }}
    role="img"
    aria-label={t("onboarding.subflow.dotsLabel", {
      current: current + 1,
      total,
    })}
  >
    {Array.from({ length: total }, (_, i) => (
      <Box
        key={i}
        sx={{
          flex: 1,
          height: 4,
          borderRadius: 999,
          transition: "background-color 0.4s",
          backgroundColor:
            i <= current ? onboardingTokens.teal : onboardingTokens.muted,
        }}
      />
    ))}
  </Stack>
);

export default SubFlowDots;
